<template>
    <div>
        <section class="hru-home-section">
            <div :class="sidemenuClass" data-mcs-theme="minimal">
                <div :class="'sidemenu-container '+sideMenuContainerClass">
                    <div class="sidemenu-list">
                        <router-link v-bind:to="{ name:'ViewLocationDepartments',params:{slug : extension_slug}}" title="Company Directory">
                            <!--<a v-on:click.prevent="toContactDirectory()">-->
                            <img src="/static/images/company-directory.png">
                            <span class="mrtop">Company Directory</span>
                            <!--</a>-->
                        </router-link>
                    </div>

                    <template v-if="userPermissions.indexOf('can_access_manager_directory') > -1">
                        <div class="sidemenu-list">
                            <router-link v-bind:to="{name: 'ManagerDirectory'}" title="Manager Directory">
                                <img src="/static/images/company-directory.png">
                                <span class="mrtop">Manager Directory</span>
                            </router-link>
                        </div>
                    </template>
                    
                    <template v-if="roleId <= 2">
                        <div class="sidemenu-list">
                            <router-link v-bind:to="{ path:'/leadershipdevelopment'}" title="Leadership and Development">
                                <img src="/static/images/updated-leadership-and-development.png">
                                <span>Leadership and<br/>
                                    Development</span>
                            </router-link>
                        </div>
                    </template>
                    <div class="sidemenu-list">
                        <router-link v-bind:to="{name: 'HrCalendar'}" title="HR Calendar">
                            <img src="/static/images/updated-hr-calendar-img.png">
                            <span class="mrtop">HR Calendar</span>
                        </router-link>
                    </div>
                     <div class="sidemenu-list">
                        <router-link v-bind:to="{ path:'/erg'}" title="Employee Resource Group">
                            <img src="/static/images/updated-surveys.png">
                            <span class="mrtop">Employee Resource Group</span>
                        </router-link>
                    </div>
                    <div class="sidemenu-list">
                        <router-link v-bind:to="{ path:'/surveys'}" title="Surveys">
                            <img src="/static/images/updated-surveys.png">
                            <span class="mrtop">Surveys</span>
                        </router-link>
                    </div>
                    <div class="sidemenu-list">
                        <router-link v-bind:to="{ path:'/employeerecognition'}" title="Employee Recognition">
                            <img src="/static/images/updated-employee-recognition.png">
                            <span>Employee<br/>
                                Recognition</span>
                        </router-link>
                    </div>

                    <div class="sidemenu-list">
                        <router-link v-bind:to="{ path:'/employeeperksprogram'}" title="Employee Perks">
                            <img src="/static/images/updated-employee-perks.png">
                            <span>Employee<br/>
                                Perks</span>
                        </router-link>
                    </div>


                    <div class="sidemenu-list">
                        <router-link v-bind:to="{ path:'/wellness'}" title="Employee Wellness">
                            <img src="/static/images/updated-employee-wellness.png">
                            <span>Employee<br/>
                                Wellness</span>
                        </router-link>
                    </div>

                    <div class="sidemenu-list">
                        <router-link v-bind:to="{ path:'/benefits'}" title="Employee Benefits">
                            <img src="/static/images/updated-employee-benefits.png">
                            <span>Employee<br/>
                                Benefits</span>
                        </router-link>
                    </div>

                    <div class="sidemenu-list">
                        <router-link v-bind:to="{ path:'/401kplan'}" title="Retirement">
                            <img src="/static/images/updated-retirement.png">
                            <span class="mrtop">Retirement</span>
                        </router-link>
                    </div>

                    <div class="sidemenu-list">
                        <router-link v-bind:to="{ path:'/gallery'}" title="Gallery">
                            <img src="/static/images/updated-gallery.png">
                            <span class="mrtop">Gallery</span>
                        </router-link>
                    </div>

                </div>
            </div>
            <!--slider 1-->
            <div class="slider-home col-12">
                <div class="container">
                    <div class="row">
                        <h2> Meet the HR Team </h2>
                        <div class="hr-team-main-section col-12 float-l"> <!--Team member section-->
                            <!--<div class=""> -->
                        <template v-if="windowWidth >= 992">
                            <div :class="'row '+ hrContainerClass"> <!--outer row-->
                                <template v-for="(text, index) in hrTeamList">
                                    <template v-if="inFirstRow >= (index + 1) && windowWidth >= 992">
                                        <div class="hr-team-member-detial col-6 col-sm-4 col-md-4 col-lg-2"> <!--Team member-->
                                            <div class="hover-home-eefect">
                                                <div class="member-img-hover">
                                                    <router-link v-bind:to="{ path:'/meethrteam/' + text.id}">
                                                        <template v-if="text.profile_image == ''">
                                                            <img src="/static/images/default.jpg" :alt="text.first_name + ' ' + text.last_name">
                                                        </template>
                                                        <template v-else>
                                                            <img :src="text.profile_image" :alt="text.first_name + ' ' + text.last_name">
                                                        </template>
                                                    </router-link>
                                                </div>
                                                <div class="team-name">
                                                    <p> {{text.first_name}} {{text.last_name}} <span> {{text.post}} </span> </p>
                                                </div>

                                                <div class="team-designation">
                                                    <p> {{text.team_designation}} </p>
                                                </div>
                                            </div>
                                        </div> <!--Team member-->
                                        <!--<template v-if="inFirstRow == (index + 1) && windowWidth >= 992">
                                            <div class="clearfix"></div>
                                        </template>-->
                                    </template>
                                </template>
                            </div> <!--outer row-->
                            <div :class="'row '+ hrContainerClass"> <!--outer row-->
                                <template v-for="(text, index) in hrTeamList">
                                    <template v-if="inFirstRow < (index + 1) && windowWidth >= 992">
                                        <div class="hr-team-member-detial col-6 col-sm-4 col-md-4 col-lg-2"> <!--Team member-->
                                            <div class="hover-home-eefect">
                                                <div class="member-img-hover">
                                                    <router-link v-bind:to="{ path:'/meethrteam/' + text.id}">
                                                        <template v-if="text.profile_image == ''">
                                                            <img src="/static/images/default.jpg" :alt="text.first_name + ' ' + text.last_name">
                                                        </template>
                                                        <template v-else>
                                                            <img :src="text.profile_image" :alt="text.first_name + ' ' + text.last_name">
                                                        </template>
                                                    </router-link>
                                                </div>
                                                <div class="team-name">
                                                    <p> {{text.first_name}} {{text.last_name}} <span> {{text.post}} </span> </p>
                                                </div>

                                                <div class="team-designation">
                                                    <p> {{text.team_designation}} </p>
                                                </div>
                                            </div>
                                        </div> <!--Team member-->
                                        <!--<template v-if="inFirstRow == (index + 1) && windowWidth >= 992">
                                            <div class="clearfix"></div>
                                        </template>-->
                                    </template>
                                </template>
                            </div> <!--outer row-->
                        </template>
                        <template v-else>
                            <div :class="'row '+ hrContainerClass"> <!--outer row-->
                                <template v-for="(text, index) in hrTeamList">
                                    <div class="hr-team-member-detial col-6 col-sm-4 col-md-4 col-lg-2"> <!--Team member-->
                                        <div class="hover-home-eefect">
                                            <div class="member-img-hover">
                                                <router-link v-bind:to="{ path:'/meethrteam/' + text.id}">
                                                    <template v-if="text.profile_image == ''">
                                                        <img src="/static/images/default.jpg" :alt="text.first_name + ' ' + text.last_name">
                                                    </template>
                                                    <template v-else>
                                                        <img :src="text.profile_image" :alt="text.first_name + ' ' + text.last_name">
                                                    </template>
                                                </router-link>
                                            </div>
                                            <div class="team-name">
                                                <p> {{text.first_name}} {{text.last_name}} <span> {{text.post}} </span> </p>
                                            </div>

                                            <div class="team-designation">
                                                <p> {{text.team_designation}} </p>
                                            </div>
                                        </div>
                                    </div> <!--Team member-->
                                </template>
                            </div> <!--outer row-->
                        </template>

                            <!--</div>-->
                        </div> <!--Team member section-->
                    </div>
                    <div class="vvg-svt-container">
                        <div class="vvg-svt-left-container">
                            <div class="vvg-svt-text">
                                <span>Our companies run on the 3 pillars of</span>
                                <!--<strong>Speed, Value & Trust</strong>-->
                            </div>
                            <img src="/static/images/svt-graphics.png" alt="Speed, Value & Trust">
                        </div>
                        <div class="vvg-svt-right-container">

                            <div class="vvg-svt-block">

                                <div class="vvg-svt-block-text">
                                    <h3>Speed</h3>
                                    <p>We focus on accelerating your career by planning for the future</p>
                                </div>
                            </div>

                            <div class="vvg-svt-block">

                                <div class="vvg-svt-block-text">
                                    <h3>Value</h3>
                                    <p>We value our team members and consider them family</p>
                                </div>
                            </div>

                            <div class="vvg-svt-block vvg-svt-block0">

                                <div class="vvg-svt-block-text">
                                    <h3>Trust</h3>
                                    <p>Every good relationship begins with trust, mutual respect and open communication<!--Every good relationship begins with trust, mutual respect and teamwork--></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!--slider-->
        <!--<section class="col-12">
            <div class="container">
                <div class="row">
                    <app-slider :sliderType='sliderType'></app-slider>
                </div>
            </div>
        </section>-->

        <!--video section-->
        <!--<section class="hru-new-section">
            <div class="col-md-6 hru-gallery">
                <span>Gallery</span>
                <section class="view_gallery_homepage">
        <!--<img class="gallery-home-bg" src="/static/images/gallery-bg-img.png" alt="Gallery Background">-->
        <!--<div class="container">-->
        <!--<div class="row">-->
        <!--<div class="gallery-top col-12">
            <div class="row">
                <template v-for="(text, index) in imageList">
                    <div class="gallery-img-detail col-12 col-sm-6 col-md-6 col-lg-6">
                        <div class="hover-home-eefect">
                            <img :src="text.image">
                        </div>
                    </div>
                    <template v-if="((Number(index) + 1)%2) == 0">
                        <div class="clearfix"></div>
                    </template>
                </template>
            </div>
        </div>
        <!--<div class="view-btn-small pt-10 col-6">
            <div class="row">
                <router-link v-bind:to="{ path:'/gallery'}" class="hvr-sweep-to-right-blue"> View Gallery </router-link>
            </div>
        </div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</section>
    </div>
    <div class="col-md-6 hru-video">
        <template v-for="(homeVideos, index) in homeVideoList">
            <template v-if="homeVideos.uploaded_type == 'url'">
                <span>{{homeVideos.video_name}}</span>
                <iframe :src="homeVideos.video_path" allow="encrypted-media" allowfullscreen="allowfullscreen" width="100%" height="345" frameborder="0"></iframe>
            </template>
            <template v-else>
                <span>{{homeVideos.video_name}}</span>
                <video style="width: 100%;" controls="controls" preload="metadata">
                    <source :src="homeVideos.video_path" type="video/mp4" />
                </video>
            </template>
        </template>
    </div>
</section>-->
        <!--<div class="clearfix"></div>
        <template>
            <div>
                <b-carousel
                    :interval="4000"
                    id="carousel-fade"
                    style="text-shadow: 0px 0px 2px #000"
                    fade
                    indicators
                    img-width="1024"
                    img-height="480"
                    >
                    <b-carousel-slide>
                        <img
                            slot="img"
                            class="d-block img-fluid pull-left"
                            style="width:33.33%;"
                            src="https://picsum.photos/1024/480/?image=58"
                            alt="image slot"
                            >
                        <img
                            slot="img"
                            class="d-block img-fluid pull-left"
                            style="width:33.33%;"
                            src="https://picsum.photos/1024/480/?image=55"
                            alt="image slot"
                            >
                        <img
                            slot="img"
                            class="d-block img-fluid pull-left"
                            style="width:33.33%;"
                            src="https://picsum.photos/1024/480/?image=54"
                            alt="image slot"
                            >
                    </b-carousel-slide>
                    <b-carousel-slide>
                        <img
                            slot="img"
                            class="d-block img-fluid pull-left"
                            style="width:33.33%;"
                            src="https://picsum.photos/1024/480/?image=54"
                            alt="image slot"
                            >
                        <img
                            slot="img"
                            class="d-block img-fluid pull-left"
                            style="width:33.33%;"
                            src="https://picsum.photos/1024/480/?image=58"
                            alt="image slot"
                            >
                        <img
                            slot="img"
                            class="d-block img-fluid pull-left"
                            style="width:33.33%;"
                            src="https://picsum.photos/1024/480/?image=55"
                            alt="image slot"
                            >
                    </b-carousel-slide>
                </b-carousel>
            </div>
        </template>-->

        <div class="ethics-hotline">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <p>
                            <!-- “At Velocity Vehicle Group, we rely on our core values of Speed, Value, and Trust. A
                            critical part of each core value is that we conduct our business in compliance with
                            all laws and regulations and in a way that demonstrates our commitment to ethics
                            and integrity. If you feel we have not fulfilled this commitment or have questions,
                            please contact us using the Speak Up Line.” -->

                            "At Velocity Vehicle Group and our affiliated companies, we are committed to doing business ethically, with integrity, and in compliance with the law. We can only achieve this commitment if we are all confident we can speak up with questions, concerns, or suggestions. We hope that you are all comfortable speaking directly with me, HR, or your manager, but in those cases when you are not, please use this Speak Up Line to contact us about your questions, concerns, or suggestions. We value your opinion and want to hear from you!"
                        </p>
                    </div>
                    <div class="col-md-6">
                        <div class="speakup-wrapper">
                            <p class="click-content">
                                Click here to make a confidential report >
                            </p>
                            <a href="https://secure.ethicspoint.com/domain/media/en/gui/92280/index.html">
                                <img src="/static/images/speak_up_line.png" class="speakup-image"/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <section class="hru-udated-page-slider">
            <span>A Great Place to Work!</span>

            <div id="carousel-example-generic" class="carousel slide" data-ride="carousel">
                <!-- Indicators -->
                <ol class="carousel-indicators">
                    <template v-for="(images, index) in imageList">
                        <template v-if="index == 0">
                            <li data-target="#carousel-example-generic" :data-slide-to="index" class="active"></li>
                        </template>
                        <template v-else>
                            <li data-target="#carousel-example-generic" :data-slide-to="index"></li>
                        </template>
                    </template>
                </ol>

                <!-- Wrapper for slides -->
                <div class="carousel-inner" role="listbox">
                    <template v-for="(images, index) in imageList">
                        <template v-if="index == 0">
                            <div class="item active">
                                <template v-for="(image, index_child) in images">
                                    <template v-if="image.type == 'image'">
                                        <img class="pull-left" :src="image.image" :alt="'Index is zero ' + image.type">
                                    </template>
                                    <template v-else>
                                        <video v-if="image.video != ''" class="pull-left" controls="controls" preload="metadata">
                                            <source :src="image.video + '#t=0.5'" type="video/mp4">
                                        </video>
                                        <iframe v-if="image.video_url != ''" class="pull-left" :src="image.video_url" controls  allowfullscreen autostart='0'></iframe>
                                    </template>
                                </template>
                            </div>
                        </template>
                        <template v-else>
                            <div class="item">
                                <template v-for="(image, index_child) in images">
                                    <template v-if="image.type == 'image'">
                                        <img class="pull-left" :src="image.image" :alt="'Index not zero ' + image.type">
                                    </template>
                                    <template v-else>
                                        <video v-if="image.video != ''" class="pull-left" controls="controls" preload="metadata">
                                            <source :src="image.video + '#t=0.5'" :type="image.media_type">
                                        </video>
                                        <iframe v-if="image.video_url != ''" class="pull-left" :src="image.video_url" controls  allowfullscreen autostart='0'></iframe>
                                    </template>
                                </template>
                            </div>
                        </template>
                    </template>
                    <!--<div class="item active">
                        <img class="pull-left" src="/static/images/homeslider/homesliderimg1.jpg" alt="...">
                        <img class="pull-left" src="/static/images/homeslider/homesliderimg2.jpg" alt="...">
                        <img class="pull-left" src="/static/images/homeslider/homesliderimg3.jpg" alt="...">
                    </div>
                    <div class="item">
                        <img class="pull-left" src="/static/images/homeslider/homesliderimg4.jpg" alt="...">
                        <img class="pull-left" src="/static/images/homeslider/homesliderimg5.jpg" alt="...">
                        <img class="pull-left" src="/static/images/homeslider/homesliderimg6.jpg" alt="...">
                    </div>
                    <div class="item">
                        <img class="pull-left" src="/static/images/homeslider/homesliderimg7.jpg" alt="...">
                        <img class="pull-left" src="/static/images/homeslider/homesliderimg8.jpg" alt="...">
                        <img class="pull-left" src="/static/images/homeslider/homesliderimg9.jpg" alt="...">
                    </div>-->
                </div>
                <!-- Controls -->
                <a class="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">
                    <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                    <span class="sr-only">Previous</span>
                </a>
                <a class="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">
                    <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                    <span class="sr-only">Next</span>
                </a>
            </div>

        </section>



        <section class="hru-updated-view-banner accordion" id="accordionExample">
            <a v-show="sliderCount > 0" href="" id="BannerButtonTitle" v-on:click.prevent="toggleBanner()">View Banner</a>
            <button style="display: none;" id="BannerButton" data-toggle="collapse" data-target="#collapseBanner" aria-expanded="false" aria-controls="collapseBanner">
                View Banner
            </button>
            <div id="collapseBanner" class="collapse" aria-labelledby="collapseBanner" data-parent="#accordionExample">
                <app-slider :sliderType='sliderType' :key='sliderType.location_type'></app-slider>
            </div>
        </section>

        <section class="hru-updated-insta-photo-container">

            <div class="hru-updated-upload-photo-container">
                <span>Upload Photos</span>
                <router-link v-bind:to="{name: 'AddPhoto'}">
                    <img src="/static/images/uploadicon.png">
                </router-link>
                <p>Click on the button to upload photos.<br/>
                    Share the images with us to <br/>
                    showcase in gallery.</p>
            </div>

            <div class="hru-updated-instragram-container">
                <!--<div
                    class="fb-page"
                    data-href="https://www.facebook.com/VelocityTruckCenters"
                    data-tabs="timeline"
                    data-width="500"
                    data-height="500"
                    data-small-header="false"
                    data-adapt-container-width="true"
                    data-hide-cover="false"
                    data-show-facepile="true">
                    <blockquote cite="https://www.facebook.com/VelocityTruckCenters" class="fb-xfbml-parse-ignore">
                        <a href="https://www.facebook.com/VelocityTruckCenters">Velocity Truck Centers</a>
                    </blockquote>
                </div>-->
                <div class="col-md-6 float-left">
                    <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FVelocityVehicleGroup%2F&tabs=timeline&width=380&height=570&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                            width="380"
                            height="570"
                            style="border:none;overflow:hidden"
                            scrolling="no"
                            frameborder="0"
                            allowTransparency="true"
                            allow="encrypted-media">
                    </iframe>
                    <!--<iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FVelocityTruckCenters&tabs=timeline&width=380&height=570&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                            width="380"
                            height="570"
                            style="border:none;overflow:hidden"
                            scrolling="no"
                            frameborder="0"
                            allowTransparency="true"
                            allow="encrypted-media">
                    </iframe>-->
                </div>

                <div id="list" class="col-md-6 float-left">
                    <div id="list" class="list-group">
                        <template v-if="events.length > 0">
                            <template v-for="(text, index) in events">
                                <button type="button" class="list-group-item list-group-item-action">{{text.title}}<br/><span class="home-page-event-time">{{text.eventdate}}</span></button>
                                <!--<div class="list-group-item list-group-item-action">{{text.title}}<span class="pull-right">{{text.eventdate}}</span></div>-->
                            </template>
                        </template>
                        <template v-else>
                            <span class="no-events">No Events <br>Available</span>
                        </template>
                    </div>
                </div>
                <!--<template>
                    <div>
                        <h1>Your template code</h1>
                        <vue-facebook-page data-href="https://www.facebook.com/VelocityTruckCenters" link-text="Velocity Truck Centers" />
                        <router-view/>
                    </div>
                </template>-->
                <!--<template v-if="clientId != ''">
                    <span>
                        <img src="/static/images/instagramsmallicon.png">
                        Join the Conversation!
                    </span>
                </template>
                <template v-else>
                    <span>
                        <img src="/static/images/instagramsmallicon.png">
                        No Feed Available!
                    </span>
                </template>
                <div class="instragram-container">

                    <div class="instragram-top-container">
                        <template v-if="instaProfile.data.profile_picture != ''">
                            <img :src="instaProfile.data.profile_picture" alt="Instagram Profile Image">
                        </template>
                        <div class="instragram-top-container-right">
                            <template v-if="instaProfile.data.full_name != ''">
                                <div class="vvg-instagram">
                                    <div class="vvgtext">
                                        {{instaProfile.data.full_name}} <img src="/static/images/symbol.png">
                                    </div>
                                </div>
                            </template>
                            <ul>
                                <template v-if="instaProfile.data.counts.media != ''">
                                    <li>{{instaProfile.data.counts.media}} posts</li>
                                </template>
                                <template v-if="instaProfile.data.counts.follows != ''">
                                    <li>{{instaProfile.data.counts.follows}} followers</li>
                                </template>
                                <template v-if="instaProfile.data.counts.followed_by != ''">
                                    <li>{{instaProfile.data.counts.followed_by}} following</li>
                                </template>
                            </ul>
                        </div>
                    </div>

                    <div class="instragram-block">
                        <template v-for="(post, index) in instaPosts">
                            <div class="insta-photo">
                                <div class="insta-img">
                                    <img :src="post.images.standard_resolution.url">
                                </div>
                                <div class="instaicons">
                                    <img data-toggle="popover" data-trigger="hover" :data-content="post.likes.count" data-placement="top" src="/static/images/like-h.png" class="likeicon">
                                    <img data-toggle="popover" data-trigger="hover" :data-content="post.comments.count" data-placement="top" src="/static/images/comment.png" class="commenticon">
                                    <a :href="post.link" target="_blank">
                                        <img data-toggle="popover" data-trigger="hover" data-placement="top" data-content="Click to view post" src="/static/images/plane.png" class="planeicon">
                                    </a>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>-->
            </div>
        </section>


        <section class="hru-updated-social-container hover14">
            <span>We’re Social</span>
            <template v-for="(social,index) in socialMediaLinks">
                <template v-if="social.social_title.value == 'facebook'">
                    <a :href="social.social_value" target="_blank"><figure><img src="/static/images/facebookicon.png"></figure></a>
                </template>
                <template v-else-if="social.social_title.value == 'instagram'">
                    <a :href="social.social_value" target="_blank"><figure><img src="/static/images/instagramicon.png"></figure></a>
                </template>
                <template v-else-if="social.social_title.value == 'linkedin'">
                    <a :href="social.social_value" target="_blank"><figure><img src="/static/images/linkedinicon.png"></figure></a>
                </template>
            </template>
        </section>


        <!-- view gallery section -->
        <!--<section class="view_gallery_homepage col-6">
            <img class="gallery-home-bg" src="/static/images/gallery-bg-img.png" alt="Gallery Background">
            <div class="container">
                <div class="row">
                    <div class="gallery-top col-12">
                        <div class="row">
                            <template v-for="(text, index) in imageList">
                                <div class="gallery-img-detail col-12 col-sm-6 col-md-6 col-lg-6">
                                    <div class="hover-home-eefect">
                                        <img :src="text.image">
                                    </div>
                                </div>
                                <template v-if="((Number(index) + 1)%2) == 0">
                                    <div class="clearfix"></div>
                                </template>
                            </template>
                        </div>
                    </div>
                    <div class="view-btn-small pt-10 col-6">
                        <div class="row">
                            <router-link v-bind:to="{ path:'/gallery'}" class="hvr-sweep-to-right-blue"> View Gallery </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>-->
        <!-- end view gallery section -->
        <!--<section class="video-main-section col-6">
            <img class="video-home-bg" src="/static/images/video-bg-img.png" alt="video Background">
            <div class="container">
                <div class="row">
                    <div class="video-img-middle">
                        <template v-for="(homeVideos, index) in homeVideoList">
                            <template v-if="homeVideos.uploaded_type == 'url'">
                                <iframe width="560" height="315" :src="homeVideos.video_path" frameborder="0" allow="encrypted-media" allowfullscreen></iframe>
                            </template>
                            <template v-else>
                                <video style="width: 100%;" controls="controls" preload="metadata">
                                    <source :src="homeVideos.video_path" type="video/mp4" />
                                </video>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </section>-->
        <!--video section-->

        <!--benefits section-->
        <!--<section class="benefits-section-main-new col-12 float-l">
            <img class="benifit-bg-img" src="/static/images/benifit-bg-map-img.png" alt="Map">
            <div class="row">
                <div class="benifit-main-section-n float-l col-12 bg-color-dadfe4">
                    <div class="container">
                        <div class="row">
                            <div class="benifit-section-left-n col-12 col-sm-4 col-md-4 col-lg-4 float-l">
                                <div class="row">
                                    <router-link v-bind:to="{ path:'/benefits'}" class="heading-text-22 line-height-26 color-blue bg-color-white center float-l hvr-sweep-to-right-blue"> Employee Benefits </router-link>
                                </div>
                            </div>
                            <div class="benifit-section-center-n col-12 col-sm-4 col-md-4 col-lg-4 float-l">
                                <div class="row">
                                    <img src="/static/images/benifit-middle-heart-img.png" alt="Benifit middle img">
                                </div>
                            </div>
                            <div class="benifit-section-left-n col-12 col-sm-4 col-md-4 col-lg-4 float-r">
                                <div class="row">
                                    <router-link v-bind:to="{ path:'/wellness'}" class="heading-text-22 line-height-26 color-blue bg-color-white center float-r hvr-sweep-to-right-blue"> Employee Wellness </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>-->
        <!--benefits section-->
        <!--wellness section-->

        <!--wellness section-->
        <!--Retirement section-->
        <!--<section class="retirement-main-section col-12">
            <div class="row">

                <div class="retirement-main-section_left col-12">
                    <div class="row">
                        <div class="middle-content">
                            <div class="top-title-section">
                                <h2> Retirement </h2>
                                <p> Transamerica enrollment website </p>
                            </div>

                            <div class="middle-title-section">
                                <a href="www.ta-retirement.com"> www.ta-retirement.com </a>
                                <p> <i class="hi-icon hr-call"> </i> 800-401-8726 </p>
                            </div>

                            <div class="view-btn-small col-12 pt-20">
                                <div class="row">
                                    <router-link v-bind:to="{ path:'/401kplan'}" class="hvr-sweep-to-right-blue"> See More </router-link>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </section>-->
        <!--Retirement section-->
        <!--bottom icon section-->
        <!--<section class="bottom-icon-section col-12">
            <div class="container">
                <div class="row">
                    <template v-if="roleId > 2">
                        <div class="bottom-icon-section-1 col-6 col-sm-6 col-md-3 col-lg-3">
                            <div class="row">
                                <div class="bottom-icon-section-img">
                                    <router-link v-bind:to="{ path:'/hrcalendar'}">
                                        <div id='holder'>
                                            <img src='/static/images/hr-calendar-img.png' alt="HR Calendar" class='front' />
                                            <img src='/static/images/hr-calendar-img.png' alt="HR Calendar" class='back' />
                                        </div>
                                    </router-link>
                                </div>
                                <p> <router-link v-bind:to="{ path:'/hrcalendar'}"> HR Calendars </router-link> </p>
                            </div>
                        </div>
                    </template>
                    <div class="bottom-icon-section-1 col-6 col-sm-6 col-md-3 col-lg-3">
                        <div class="row">
                            <div class="bottom-icon-section-img">
                                <router-link v-bind:to="{ path:'/employeeperksprogram'}">
                                    <div id='holder'>
                                        <img src='/static/images/access-icon-img.png' alt="Employee Perks" class='front' />
                                        <img src='/static/images/access-icon-img.png' alt="Employee Perks" class='back' />
                                    </div>
                                </router-link>
                            </div>
                            <p> <router-link v-bind:to="{ path:'/employeeperksprogram'}"> Employee Perks </router-link> </p>
                        </div>
                    </div>
                    <div class="bottom-icon-section-1 col-6 col-sm-6 col-md-3 col-lg-3">
                        <div class="row">
                            <div class="bottom-icon-section-img">
                                <router-link v-bind:to="{ path:'/employeerecognition'}">
                                    <div id='holder'>
                                        <img src='/static/images/employee-recognation.png' alt="Employee Recognition" class='front' />
                                        <img src='/static/images/employee-recognation.png' alt="Employee Recognition" class='back' />
                                    </div>
                                </router-link>
                            </div>
                            <p> <router-link v-bind:to="{ path:'/employeerecognition'}"> Employee Recognition </router-link> </p>
                        </div>
                    </div>
                    <div class="bottom-icon-section-1 col-6 col-sm-6 col-md-3 col-lg-3">
                        <div class="row">
                            <div class="bottom-icon-section-img">
                                <router-link v-bind:to="{ path:'/surveys'}">
                                    <div id='holder'>
                                        <img src='/static/images/survey-img.png' alt="Survey" class='front' />
                                        <img src='/static/images/survey-img.png' alt="Survey" class='back' />
                                    </div>
                                </router-link>
                            </div>
                            <p> <router-link v-bind:to="{ path:'/surveys'}"> Surveys </router-link> </p>
                        </div>
                    </div>
                    <template v-if="roleId <= 2">
                        <div class="bottom-icon-section-1 col-6 col-sm-6 col-md-3 col-lg-3">
                            <div class="row">
                                <div class="bottom-icon-section-img">
                                    <router-link v-bind:to="{ path:'/leadershipdevelopment'}">
                                        <div id='holder'>
                                            <img src='/static/images/leadership.png' alt="Leadership and Development" class='front' />
                                            <img src='/static/images/leadership.png' alt="Leadership and Development" class='back' />
                                        </div>
                                    </router-link>
                                </div>
                                <p> <router-link v-bind:to="{ path:'/leadershipdevelopment'}"> Leadership and Development </router-link> </p>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </section>-->
    </div>
</template>
<script>
    import axios from 'axios';
    import index from "../router";
    import EventBus from "./event-bus";
    import Vue from "vue";
    import SessioMixin from '../mixins/sessionmixin';
    import {HTTP} from '../http-common';
    import moment from 'moment';
    import SliderComponent from "@/components/SliderComponent";
    import bCarousel from 'bootstrap-vue/es/components/carousel/carousel';
    import bCarouselSlide from 'bootstrap-vue/es/components/carousel/carousel-slide';
    var self;
    export default {
        /*import * as mykey from '/static/js/jquery.rotateSlider.js',*/
        name: "Home",
        components: {
            'app-slider': SliderComponent,
            'b-carousel': bCarousel,
            'b-carousel-slide': bCarouselSlide,
        },
        mixins: [SessioMixin],
        data() {
            return {
                safetyURL: "",
                sidemenuClass: "sidemenu mCustomScrollbar",
                extension_slug: '',
                startDate: 0,
                startDate: 0,
                endDate: 0,
                events: [],
                sliderType: {
                    type: 'home',
                },
                clientId: "",
                redirectUrl: "",
                instaToken: "",
                instaProfile: {
                    data: {
                        profile_picture: '',
                        full_name: '',
                        counts: {
                            media: '',
                            follows: '',
                            followed_by: '',
                        }
                    }
                },
                instaPosts: [],
                instaPageUrl: "",
                userPermissions: [],
                roleId: 0,
                roleName: 0,
                system_year: '',
                cantAccessPage: true,
                permissions: [],
                isShowLoggedinfields: true,
                firstName: "",
                lastName: "",
                userName: "",
                loginID: 0,
                imageList: [],
                hrTeamList: [],
                inFirstRow: 6,
                hrContainerClass: "",
                sideMenuContainerClass: "",
                homeVideoList: [],
                homeVideoLinkIndex: [],
                error: '',
                bannerVisible: 0,
                sliderCount: 0,
                windowWidth: 0,
                payroll: '',
                hr_email: '',
                hr_admin_number: '',
                employee_hotline: '',
                socialMediaLinks: [],
            };
        },
        beforeMount: function () {
            self = this;
            var token = localStorage.getItem("api_token");
            self.checkLogin();
        },
        created: function () {
        },
        mounted: function () {
            self.MenuClose();
            self.getBuildVersion();

            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();
            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            self.startDate = yyyy + "-" + mm + "-" + dd;
            self.endDate = (yyyy + 1) + "-" + mm + "-" + dd;

            var instaURL = window.location.href;
            var InstaSegments = instaURL.split("/");
            let token = "";
            if (InstaSegments[3]) {
                token = InstaSegments[3];
                token = token.split("=");
                token = token[1];

            }
            //*self.AddInstagramToken(token);*/
            $('#main-header').show();
            $('#main-footer').show();
            $("html, body").animate({scrollTop: 0}, 10);
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            } else {
                self.$router.push("/login");
            }
            self.getPermissions();
            self.loadSlider();
            self.getImages();
            self.getHRTeam();
            self.loadHomeVideo();
            self.loadCalendarEvents();
            self.loadHRContact();
            self.windowWidth = $(window).width();
            /*$(window).resize(function () {
                self.windowWidth = $(window).width();
            });
            self.manageCustomScroll();*/
        },
        watch: {
            instaToken: function (instaToken) {
                if (instaToken != "") {
                    self.GetInstagramData();
                }
            },
            /*windowWidth: function (windowWidth) {
                self.manageCustomScroll();
            },*/
        },
        methods: {
            /*manageCustomScroll() {
                if (self.windowWidth > 667) {
                    self.sidemenuClass = "sidemenu mCustomScrollbar";
                    self.$nextTick(function () {
                        $(".sidemenu").mCustomScrollbar({
                            scrollButtons:{
                                enable:true,
                            },
                        });
                    });
                }else{
                    self.sidemenuClass = "sidemenu";
                    self.$nextTick(function () {
                        $(".sidemenu").mCustomScrollbar("destroy");
                    });
                }
            },*/
            toContactDirectory() {
                openDirectLink("/directory/extensions/" + self.extension_slug);
            },
            loadHRContact() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    /*params: {
                     'type': self.categoryType,
                     }*/
                };

                HTTP.get("getcontacthr", config)
                        .then(function (response) {
                            self.payroll = response.data.content.payroll_email;
                            self.hr_email = response.data.content.hr_email;
                            self.hr_admin_number = response.data.content.hr_admin_contact;
                            self.employee_hotline = response.data.content.employee_hotline;
                            self.socialMediaLinks = response.data.content.social_links;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadSlider() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: 0,
                    type: 'home',
                };

                HTTP.post("getslider", data, config)
                        .then(function (response) {
                            if (response.data.code == '200') {
                                self.sliderCount = response.data.content.length;
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            toggleBanner: function (props) {
                $('#BannerButton').click();
                if (self.bannerVisible == 0) {
                    self.bannerVisible = 1;
                    $('#BannerButtonTitle').html('Hide Banner');
                } else {
                    self.bannerVisible = 0;
                    $('#BannerButtonTitle').html('View Banner');
                }
            },
            instaError: function (props) {
                alert(JSON.stringify(props));
            },
            AddInstagramToken(token) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var data = {
                    token: token,
                };
                HTTP.post("getset_insta_token", data, config)
                        .then(function (response) {
                            if (response.data.status == "success") {
                                self.instaToken = response.data.content.token;
                                self.clientId = response.data.content.client_id;
                                self.redirectUrl = response.data.content.redirect_url;
                            }
                            if (token != "") {
                                self.$router.push('/');
                            }
                        })
                        .catch(function (err) {
                            self.clientId = err.response.data.content.client_id;
                            self.redirectUrl = err.response.data.content.redirect_url;
                            self.generateInstaToken();
                            /*console.log("Exception Wile getting Instagram Auth details");*/
                        });
            },
            GetInstagramData() {
                let self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        token: self.instaToken,
                        url: self.instaPageUrl,
                    }
                };
                HTTP.get("getinstapost", config)
                        .then(function (response) {
                            if (response.data.code == 200) {
                                self.instaProfile = response.data.content.profile;
                                if (response.data.content.posts.data === null || typeof response.data.content.posts.data === "undefined") {
                                    self.instaPosts = [];
                                } else {
                                    $.each(response.data.content.posts.data, function (i) {
                                        self.instaPosts.push(response.data.content.posts.data[i]);
                                    });
                                }
                                if (response.data.content.posts.pagination.next_url === null || typeof response.data.content.posts.pagination.next_url === "undefined") {
                                    self.instaPageUrl = "";
                                } else {
                                    self.instaPageUrl = response.data.content.posts.pagination.next_url;
                                }
                                self.$nextTick(function () {
                                    $('[data-toggle="popover"]').popover();
                                });
                                /*setTimeout(function () {
                                 $('[data-toggle="popover"]').popover();
                                 }, 1000);*/
                            }
                        })
                        .catch(function (err) {
                            self.generateInstaToken();
                        });
            },
            generateInstaToken() {
                if (self.clientId != "") {
                    let getuserUrl = "https://api.instagram.com/oauth/authorize/?client_id=" + self.clientId + "&redirect_uri=" + self.redirectUrl + "&response_type=token";
                    self.instaToken = "";
                    window.location.href = getuserUrl;
                }
            },
            loadHomeVideo() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };

                var data = {
                    id: segments[4],
                    type: self.sliderType.type,
                };

                HTTP.post("getvideo", data, config)
                        .then(function (response) {
                            self.homeVideoList = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            getHRTeam: function () {
                var fields = {id: 0};
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post('gethrteam', fields, config).
//                HTTP.post('getregisteruser', '', config).
                        then(response => {
                            self.hrTeamList = response.data.content;
                            self.inFirstRow = 6;
                            self.hrContainerClass = self.sideMenuContainerClass = "";
                            if (response.data.content.length > 6) {
                                self.inFirstRow = Math.floor((response.data.content.length / 2));
                                self.hrContainerClass = "HomeHrContainer";
                                self.sideMenuContainerClass = "SideMenuRowContainer";
                            }
                            /*setTimeout(function () {
                             $('#slider').rotateSlider({});
                             }, 500);*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            getImages() {
                self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    limit: 4,
                    sort: 'created_at',
                    type: 'all',
                };
                HTTP.post("getmedia", fields, config)
                        .then(function (response) {
                            self.imageList = response.data.content;
                            self.imageList = [];
                            let tempdata = [];
                            $.each(response.data.content, function (i) {
                                tempdata.push(response.data.content[i]);
                                if ((i + 1) % 3 == 0) {
                                    self.imageList.push(tempdata);
                                    tempdata = [];
                                }
                                if ((i + 1) == response.data.content.length) {
                                    if (tempdata.length > 0) {
                                        self.imageList.push(tempdata);
                                        tempdata = [];
                                    }
                                }
                            });
                            /*console.log(self.imageList);*/
                            self.$nextTick(function () {
                                $('.hru-video').css({
                                    height: Number(Number($(".hru-gallery").height()) + 139) + "px",
                                });
                                $('.carousel').carousel({
                                    interval: 5000
                                });
                            });
                            /*setTimeout(function () {
                             $('.hru-video').css({
                             height: Number(Number($(".hru-gallery").height()) + 139) + "px",
                             });
                             $('.carousel').carousel({
                             interval: 5000
                             });
                             }, 1000);*/
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                    self.$router.push("/login");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            loadCalendarEvents() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    role_id: 0,
                    location_id: 0,
                    start_date: self.startDate,
                    end_date: self.endDate,
                };
                HTTP.post("getevents", fields, config)
                        .then(function (response) {
                            self.events = response.data.content;
                            self.events = [];
                            $.each(response.data.content, function (i) {
                                self.events.push(response.data.content[i]);
                                if ((i + 1) == 10) {
                                    return false;
                                }
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        }
    };
    EventBus.$on('role', function (isLogin, id, name, system_year, userPermissions) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.roleId = id;
            self.roleName = name;
            self.system_year = system_year;
            self.userPermissions = userPermissions;
        }
    });
    EventBus.$on('logged-in', function (isLogin, fname, lname, email) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.firstName = fname;
            self.lastName = lname;
            self.userName = email;
        }
    });
    EventBus.$on('contact', function (isLogin, company, safetyLink) {
        if (typeof (self) != "undefined") {
            self.isShowLoggedinfields = isLogin;
            self.extension_slug = company;
            self.safetyURL = process.env.SAFETY_URL;
            self.safetyURL = self.safetyURL + "login?token=" + safetyLink;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/Home.vue